<section
  class="cd"
  data-testid="call-decision"
  [attr.aria-labelledby]="questionId()"
  [attr.aria-busy]="busy() ? 'true' : null"
>
  @switch (variant()) {
    @case ('loop') {
      <h3 class="cd__question" [id]="questionId()" data-testid="call-decision-question">
        {{ 'testRunner.callDecision.loopQuestion' | translate: { module: moduleName() } }}
      </h3>
      <p class="cd__condition" data-testid="call-decision-condition">{{ loopHint() }}</p>
      <div class="cd__actions">
        <button
          type="button"
          class="cd__primary"
          data-testid="loop-next-pass"
          [disabled]="locked()"
          (click)="answer(true)"
        >
          {{ 'testRunner.callDecision.loopNext' | translate }}
        </button>
        <button
          type="button"
          class="cd__secondary"
          data-testid="loop-finish"
          [disabled]="locked()"
          (click)="answer(false)"
        >
          {{ 'testRunner.callDecision.loopFinish' | translate }}
        </button>
      </div>
      @if (call().openCall?.returnPath) {
        <p class="cd__hint" data-testid="call-decision-return-hint">
          {{ 'testRunner.callDecision.returnHint' | translate: { count: rounds() ?? 0 } }}
        </p>
      }
    }
    @default {
      @if (showRows()) {
        <h3 class="cd__question" [id]="questionId()" data-testid="call-decision-question">
          {{ 'testRunner.callDecision.rowsQuestion' | translate: { sheet: sheet()?.name ?? '' } }}
        </h3>
        <p class="cd__condition" data-testid="call-decision-condition">
          {{ 'testRunner.callDecision.rowsHint' | translate: { expression: rowsExpression() } }}
        </p>
        <div class="cd__scroll">
          <table class="cd__table" data-testid="call-decision-rows">
            <thead>
              <tr>
                <th scope="col" class="cd__select"><span class="cd__sr-only">#</span></th>
                <th scope="col" class="cd__index">#</th>
                @for (column of sheet()?.columns ?? []; track column) {
                  <th scope="col" class="cd__var">{{ column }}</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (entry of sheetRows(); track entry.nr) {
                <tr [class.cd__row--inactive]="!entry.active">
                  <td class="cd__select">
                    <mat-checkbox
                      [attr.data-testid]="'call-decision-row-' + entry.nr"
                      [aria-label]="'testRunner.callDecision.rowSelect' | translate: { n: entry.nr }"
                      [checked]="selectedRows().has(entry.nr)"
                      [disabled]="!entry.active || locked()"
                      (change)="toggleRow(entry.nr, $event.checked)"
                    />
                  </td>
                  <td class="cd__index">
                    {{ entry.nr }}
                    @if (!entry.active) {
                      <span class="cd__inactive">{{ 'testRunner.callDecision.rowInactive' | translate }}</span>
                    }
                  </td>
                  @for (column of sheet()?.columns ?? []; track column) {
                    <td>{{ entry.row[column] }}</td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
        <div class="cd__actions">
          <button
            type="button"
            class="cd__primary"
            data-testid="call-decision-apply"
            [disabled]="locked() || selectedRows().size === 0"
            (click)="applyRows()"
          >
            {{ 'testRunner.callDecision.apply' | translate }}
          </button>
          <button
            type="button"
            class="cd__link"
            data-testid="call-decision-skip-rows"
            [disabled]="locked()"
            (click)="skipRows()"
          >
            {{ 'testRunner.callDecision.skipRows' | translate }}
          </button>
        </div>
      } @else {
        <h3 class="cd__question" [id]="questionId()" data-testid="call-decision-question">
          {{ 'testRunner.callDecision.question' | translate: { module: moduleName() } }}
        </h3>
        @if (conditionText(); as text) {
          <p class="cd__condition" data-testid="call-decision-condition">
            {{ 'testRunner.callDecision.conditionLabel' | translate: { text } }}
          </p>
        } @else if (call().openCall) {
          <p class="cd__condition" data-testid="call-decision-condition">
            {{ 'testRunner.callDecision.noCondition' | translate }}
          </p>
        }
        <div class="cd__actions">
          <button
            type="button"
            class="cd__primary"
            data-testid="call-decision-yes"
            [disabled]="locked()"
            (click)="answer(true)"
          >
            {{ 'testRunner.callDecision.yes' | translate }}
          </button>
          <button
            type="button"
            class="cd__secondary"
            data-testid="call-decision-no"
            [disabled]="locked()"
            (click)="answer(false)"
          >
            {{ 'testRunner.callDecision.no' | translate }}
          </button>
        </div>
      }
    }
  }
  @if (busy()) {
    <p class="cd__busy" role="status" data-testid="call-decision-spinner">
      <mat-spinner diameter="16" />
      {{ 'testRunner.callDecision.busy' | translate }}
    </p>
  }
</section>
